import { useRef, useState } from "react";
import { Camera, Image as ImageIcon, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { shrink } from "@/components/PhotoPicker";
import { api, errMsg } from "@/lib/api";

export const uploadQueue = async (url, photos) => {
  let ok = 0;
  for (const photo of photos) {
    try { await api.post(url, { photo }); ok += 1; } catch (err) { toast.error(errMsg(err)); break; }
  }
  return ok;
};

export const PhotoQueue = ({ photos, setPhotos, max = 8, id = "photo-queue" }) => {
  const gal = useRef(null);
  const cam = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const files = [...(e.target.files || [])].filter((f) => f.type.startsWith("image/")).slice(0, max - photos.length);
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    try { const out = []; for (const f of files) out.push(await shrink(f)); setPhotos([...photos, ...out]); } catch { toast.error("No se ha podido leer alguna foto"); }
    setBusy(false);
  };
  const tile = "aspect-square w-full rounded-xl border-2 border-dashed border-slate-300 hover:border-slate-500 bg-slate-50 flex flex-col items-center justify-center gap-1 text-xs font-bold text-slate-700";
  return (
    <div data-testid={id}>
      <input ref={gal} type="file" accept="image/*" multiple onChange={pick} className="hidden" data-testid={`${id}-input`} />
      <input ref={cam} type="file" accept="image/*" capture="environment" onChange={pick} className="hidden" data-testid={`${id}-camera-input`} />
      <div className="grid grid-cols-4 sm:grid-cols-6 gap-2">
        {photos.map((p, i) => (
          <div key={p.slice(-24) + i} className="relative aspect-square rounded-xl overflow-hidden bg-slate-100">
            <img src={p} alt="" className="w-full h-full object-cover" />
            {i === 0 && <span className="absolute bottom-1 left-1 bg-black/60 text-white text-[10px] font-bold px-1.5 py-0.5 rounded">Portada</span>}
            <button type="button" onClick={() => setPhotos(photos.filter((_, j) => j !== i))} className="absolute top-1 right-1 bg-white/90 rounded-full p-0.5" aria-label="Quitar foto" data-testid={`${id}-remove-${i}`}><X size={12} /></button>
          </div>
        ))}
        {busy && <div className={tile}><Loader2 className="animate-spin" /></div>}
        {!busy && photos.length < max && (<>
          <button type="button" onClick={() => gal.current?.click()} className={tile} data-testid={`${id}-gallery`}><ImageIcon size={18} /> Subir fotos</button>
          <button type="button" onClick={() => cam.current?.click()} className={tile} data-testid={`${id}-camera`}><Camera size={18} /> Hacer foto</button>
        </>)}
      </div>
      <p className="text-xs text-slate-500 mt-1.5">{photos.length}/{max} fotos · la primera será la portada.</p>
    </div>
  );
};
